import type { Country } from '@indutrust/shared-model';
import { createCrudEvents } from '@indutrust/shared-util';

/**
 * Events for CRUD operations on Country entities.
 *
 * Manages the complete lifecycle of country data operations:
 * - loadAll, loadById, add, edit, delete
 * Each operation has request, success, and failure variants.
 *
 * Uses 'shared.country' as the event source namespace for Redux DevTools debugging.
 *
 * @example
 * const dispatch = injectDispatch(countryEvents);
 * dispatch.loadAllRequested({ params: {} });
 */
export const countryCrudEvents = createCrudEvents<Country>('country');
